export default {"src":"/_next/static/media/minus-icon.6e87d4d6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};